import {Component, Input, OnInit, AfterViewInit} from '@angular/core';
import {InfluencerPostService} from '../../../services/influencer-post/influencer-post.service';
import {Post} from '../../../../models/post-overview';
import * as Sentry from '@sentry/browser';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';
import {DatePipe} from '@angular/common';
import {platformIconPath} from '../../../app.constants';
import {TranslateService} from '@ngx-translate/core';
import {CacheService} from '../../../services/cache/cache.service';

@Component({
  selector: 'same-influencer-top-five-posts',
  templateUrl: './same-influencer-top-five-posts.component.html',
  styleUrls: ['./same-influencer-top-five-posts.component.scss']
})
export class SameInfluencerTopFivePostsComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'SameInfluencerTopFivePostsComponent';
  @Input()
  public influencerId: number | 0;
  @Input()
  public urlHash: string | null;
  @Input()
  public numberOfPosts: string | null;
  @Input()
  public currentPost: Post | null;
  @Input()
  public onlyForPaidUser = false;

  public topPosts: Array<Post> | null;

  constructor(private influencerPostService: InfluencerPostService,
              private userService: UserService,
              private cacheService: CacheService,
              private translate: TranslateService,
              private pdfService: PdfExportService) { }

  ngOnInit() {
    this.cacheService.get(`top_posts_${this.influencerId}`,
      this.influencerPostService.getTopPosts(this.influencerId, this.numberOfPosts, this.currentPost.performingScore)).subscribe((data) => {
        this.topPosts = data;
        const hasContainCurrentPost = this.topPosts.filter(p => p.urlHash === this.currentPost.urlHash).length > 0;
        if (!hasContainCurrentPost) {
          if (this.topPosts.length > 5) {
            this.topPosts = this.replaceByCurrentPostIntoTopPost(this.topPosts, this.currentPost);
          } else {
            this.topPosts = this.addCurrentPostIntoTopPost(this.topPosts, this.currentPost);
          }
        }
      }, (error) => {
          Sentry.captureException(new Error('An error happen when fetching top posts.'));
      });
  }

  replaceByCurrentPostIntoTopPost(topPosts, currentPost) {
    const newTopPosts = topPosts;
    if (currentPost.postRank > 5) {
      newTopPosts.splice(topPosts.length - 1, 1, this.currentPost);
    } else {
      newTopPosts.splice(currentPost.postRank - 1, 1, this.currentPost);
    }
    return newTopPosts;
  }

  addCurrentPostIntoTopPost(topPosts, currentPost) {
    const newTopPosts = topPosts;
    if (currentPost.postRank > topPosts.length) {
      newTopPosts.push(this.currentPost);
    } else {
      newTopPosts.splice(currentPost.postRank - 1, 0, this.currentPost);
    }
    return newTopPosts;
  }

  goToPost(postUrl: string) {
    if (postUrl) {
      window.open(postUrl, '_blank');
    }
  }

  getTitle(fullTitle) {
    if (!fullTitle) {
      return '';
    }
    return fullTitle.slice(0, 50) + '...';
  }

  getPlatformIcon(id: number) {
    return this.influencerPostService.getPlatformIconById(id);
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(SameInfluencerTopFivePostsComponent.COMPONENT_NAME);
  }


  isCurrentPost(post: Post) {
    return this.currentPost.urlHash === post.urlHash;
  }

  get showFallbackView() {
    if (this.onlyForPaidUser && this.userService.isFreeUser()) {
      return true;
    }

    return !this.topPosts || this.topPosts.length === 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/post-overview/same-influencer-top-five-posts/same-influencer-top-five-posts.component.ts